export default __webpack_public_path__ + "c6d868c9cac99b2a1d218a5ae93bcf9a.png";